<template>
  <div class="f14" v-show="images_total > 0">
    <div class="header d-grid" :class="'grid-' + images_total">
      <div>{{ localStorage.translations.pages.finance['period-table'].position }}</div>
      <div>{{ localStorage.translations.pages.finance['period-table'].description }}</div>
      <div v-for="i in images_total" :key="i">
        {{ localStorage.translations.pages.finance['period-table'].image }} {{ i }}
      </div>
    </div>
    <div v-for="(day, d) in days" :key="d">
      <div v-for="(work, w, work_key) in day.work_types" :key="'day.work_types' + w">
        <div v-for="(report, r) in work.reports" :key="'day.work_types.report' + r" class="p-rel">
          <div v-if="report?.image?.images?.length > 0" class="cells d-grid" :class="'grid-' + images_total">
            <div class="cell">{{ work_key + 1 }}</div>
            <div class="cell">{{ day.date }} {{ work.name }}</div>
            <div v-for="i in images_total" :key="i">
              <v-img
                :src="apiDomain + '/min/' + report.image.images[i - 1]"
                :width="718 / images_total"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-for="(work, w, work_key) in day.extras" :key="'day.extras' + w">
        <div v-for="(report, r) in work.reports" :key="'day.work_types.report' + r" class="p-rel">
          <div v-if="report?.image?.images?.length > 0" class="cells d-grid" :class="'grid-' + images_total">
            <div class="cell">{{ day.work_types ? Object.keys(day.work_types).length + 1 : 1 }}.{{ work_key + 1 }}</div>
            <div class="cell">{{ day.date }} {{ work.name }}</div>
            <div v-for="i in images_total" :key="i">
              <v-img
                :src="apiDomain + '/min/' + report.image.images[i - 1]"
                :width="718 / images_total"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "StatisticProjectReportsBlankConfirmTableImagesByDays",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    confirmed: {
      type: Object,
      default: () => {
        return {
          work_types: [],
          extras: []
        }
      }
    },
    images: Boolean,
    onChangeImagesCount: {}
  },
  data: () => ({
    images_count: [0],
  }),
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
    images_total() {
      console.log('this.images_count', this.images_count)
      return Math.max(...this.images_count) > 5 ? 5 : Math.max(...this.images_count)
    },
    days() {
      let days = {}
      let arr = ['work_types', 'extras']
      for (let r in arr) {
        let field = arr[r]
        for (const workKey in this.data[field]) {
          const currentWork = this.data[field][workKey]
          for (const dayKey in currentWork.days) {
            let date = dayKey.split('-')
            if (currentWork.days[dayKey].reports) {
              let data = {
                name: currentWork.name,
                measure: currentWork.measure,
                is_hourly: currentWork.is_hourly,
                reports: currentWork.days[dayKey].reports.filter(i => i.approved_report > 0 && i['client_bill_id'] === null && (this.confirmed['work_types'].includes(i.id) || this.confirmed['extras'].includes(i.id)))
              }
              if (data.reports.length > 0) {
                for (let q in data.reports) {
                  console.log('????? data.reports[q].image', data.reports[q].image)
                 // data.reports[q].image = data.reports[q].image && typeof data.reports[q].image === 'string' ? JSON.parse(data.reports[q].image).images : []
                  if (data.reports[q].image?.images?.length) {
                    this.images_count.push(data.reports[q].image?.images?.length)
                  }
                }
                if (days[dayKey]) {
                  if (!days[dayKey][field]) {
                    days[dayKey][field] = {}
                  }
                  days[dayKey][field][workKey] = data
                } else {
                  days[dayKey] = {}
                  days[dayKey][field] = {}
                  days[dayKey][field][workKey] = data
                }
                days[dayKey].date = date[2] + '/' + date[1]
              }
            }
          }
        }
      }
      return Object.keys(days).sort().reduce(
        (accumulator, index) => ({
          ...accumulator,
          [index]: days[index],
        }), {}
      )
    },
  },
  methods: {
    changeImageCount(plus, id) {
      console.log('aaa')
      if (this.images_count.value[id]) {
        if (plus) {
          this.images_count.value[id] = this.images_count.value[id] + 1
        } else {
          this.images_count.value[id] = this.images_count.value[id] - 1
        }
      } else {
        if (plus) {
          this.images_count.value[id] = 2
        }
      }
      this.images_count.key++
      console.log(this.images_count)
      if (this.onChangeImagesCount) {
        this.onChangeImagesCount(this.images_count.value)
      }
    }
  },
})
</script>

<style scoped lang="scss">
.d-grid {
  display: grid;
}

.grid-1 {
  grid-template-columns: 80px 150px 1fr;
}

.grid-2 {
  grid-template-columns: 80px 150px 1fr 1fr;
}

.grid-3 {
  grid-template-columns: 80px 150px 1fr 1fr 1fr;
}

.grid-4 {
  grid-template-columns: 80px 150px 1fr 1fr 1fr 1fr;
}

.grid-5 {
  grid-template-columns: 80px 150px 1fr 1fr 1fr 1fr 1fr;
}

.header {
  background: #f2f2f2;

  & > div {
    min-height: 30px;
    border: 1px solid #ebebeb;
    padding: 4px 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.cells {
  & > div {
    border: 1px solid #ebebeb;
  }
}

.cell {
  min-height: 30px;
  padding: 4px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p-rel {
  position: relative;
}

.p-abs {
  position: absolute;
  right: -50px;
  top: 0;
}
</style>